import React, { useEffect, useState } from "react";
import { fetchPrograms } from "@/lib/lnlApi";

const LEVEL_LABEL = { college: "College", shs: "Senior High School", graduate: "Graduate", tvl: "Technical-Vocational" };

export default function ProgramSelect({ value, onChange, className, testid }) {
    const [programs, setPrograms] = useState([]);
    useEffect(() => { fetchPrograms().then((r) => setPrograms(r || [])).catch(() => setPrograms([])); }, []);
    const groups = programs.reduce((acc, p) => { (acc[p.level || "college"] ||= []).push(p); return acc; }, {});
    return (
        <select value={value || ""} onChange={(e) => onChange(e.target.value)} className={className} data-testid={testid}>
            <option value="">Select a program…</option>
            {Object.entries(groups).map(([lvl, rows]) => (
                <optgroup key={lvl} label={LEVEL_LABEL[lvl] || lvl}>
                    {rows.sort((a, b) => a.name.localeCompare(b.name)).map((p) => <option key={p.slug} value={p.slug}>{p.name}</option>)}
                </optgroup>
            ))}
            <option value="Undecided">Not sure yet</option>
        </select>
    );
}
